import React from "react";
import "./EditorialGalleryOn.css";

function EditorialGalleryOn(props) {
  const { children } = props;

  return (
    <div className="editorial-gallery-on">
      <div className="editorial-1 poppins-medium-white-10px">{children}</div>
    </div>
  );
}

export default EditorialGalleryOn;
